import { useState } from "react";

interface IUseCode {
  saveCode: (code: string) => void;
  code: string;
  callbackWithUrlCode: URL | null;
}

interface UseCodeProps {
  callbackUrl: string;
}

function useCode({ callbackUrl }: UseCodeProps): IUseCode {
  const [code, setCode] = useState<string>("");
  const [callbackWithUrlCode, setCallbackWithUrlCode] = useState<URL | null>(
    null
  );

  const saveCode = (userCode: string) => {
    const newCallbackUrl = new URL(callbackUrl);
    newCallbackUrl.searchParams.set("code", userCode);
    setCallbackWithUrlCode(newCallbackUrl);
    setCode(userCode);
  };

  return {
    saveCode,
    code,
    callbackWithUrlCode,
  };
}

export default useCode;
